import { DiffActionTypeEnum, TransparencyEnum } from "@clockwise/schema";
import { EventType } from "@clockwise/web-commons/src/util/ActiveEventContext";
import { Interval } from "luxon";
import { ModifiedPlannerEventCardDiff, PlannerEventCard } from "../../web-app-calendar/types";
import { useCurrentProposal } from "../CurrentProposalContext";

const useCurrentProposalCards = (): {
  cardsByDay: PlannerEventCard[];
  modifiedCardDiffs: ModifiedPlannerEventCardDiff[];
  isScheduleByMoving: boolean;
  error: null;
  loading: boolean;
} | null => {
  const { currentProposal } = useCurrentProposal();

  if (!currentProposal.initialized) {
    return null;
  }

  // transform it into a PlannerEventCard
  const cardsByDay: PlannerEventCard[] = [
    {
      active: false,
      annotaion: undefined,
      deemphasis: false,
      externalEventId: undefined,
      interval: Interval.fromDateTimes(currentProposal.startTime, currentProposal.endTime),
      updatedTimeInterval: undefined,
      currentTimeInterval: undefined,
      proposedResponseState: undefined,
      isAllDay: currentProposal.allDay,
      isCancelled: false,
      smartHold: null, // Only calendar Events need this UI
      diffSummaryId: "", // what does this do
      key: `${currentProposal.title}-${currentProposal.startTime.toISO()}`,
      proposalType: DiffActionTypeEnum.ADD,
      suppressNewBadge: true,
      responseState: "Proposed",
      text: currentProposal.title,
      calendarIds: [], // what does this do
      attendeesCalendarIds: [], // Intentionally empty so that the event stripes are not shown
      affectedAttendees: [],
      attendees: [],
      locked: false,
      transparency: TransparencyEnum.None,
      videoLink: null,
      eventPermissions: {
        canInviteOthers: false,
        canModify: false,
        canDelete: false,
        canRemove: false,
        canRSVP: false,
        canSeeOtherGuests: false,
      },
      flexStatus: null,
      attendeeCount: currentProposal.attendees.length,
      proposalMetaData: {
        attendeeIds: currentProposal.attendees.map((a) => a.person.email),
        isConsequence: false, // what does this do
      },
      type: EventType.Event, // what does this do
    },
  ];

  return {
    cardsByDay,
    modifiedCardDiffs: [],
    isScheduleByMoving: false,
    error: null,
    loading: false,
  };
};

export default useCurrentProposalCards;
